module.exports = __webpack_public_path__ + "static/media/referral-illustration.b00fed45.png";